import React from 'react';
import { IProps } from 'components/Accordion/Header/types';

const Header: React.FC<IProps> = (props) => {
  const { title, link, accordionActive, handleToggleAccordion, children } = props;
  const toggleBtnClassNameModifier = accordionActive ? 'close' : 'open';

  const handleClick = () => {
    if (link) {
      window.open(link, '_blank');
    } else {
      handleToggleAccordion && handleToggleAccordion();
    }
  };

  return (
    <div className={'accordion__item-header' + (link ? ' accordion__item-header--link' : '')} onClick={handleClick}>
      <span>
        {title}
      </span>
      {children}
      {!link && (
        <button type="button" className={`accordion__toggle-btn--${toggleBtnClassNameModifier}`} />
      )}
    </div>
  );
};

export default Header;
